import React from 'react';
import {PageTitle} from '../../common/pageTitle/PageTitle';
import phoneImage from './assets/phone_2x.png';
import emailImage from './assets/email_2x.png';
import computerImage from './assets/computer_2x.png';
import {Helmet} from 'react-helmet';
import './resourcesPage.scss';

/**
 * The ResourcesPage component.
 *
 * @constructor
 */
export class ResourcesPage extends React.Component {
  /**
   * @constructor
   * @param {{}} props
   * @param {{}} componentContext
   */
  constructor(props, componentContext) {
    super(props, componentContext);
  }

  /**
   * Renders the component.
   *
   * @returns {{}}
   */
  render() {
    return (
      <div id="resources-page" className="system-page">
        <div className="container">
          <Helmet>
            <title>Safe Digging Resources - NEI</title>
            <meta name = "description" content ="811 resources to help you ensure safety to utilities and yourself" />
          </Helmet>
          <div className="row">
            <div className="col">
              <h1>General Resources</h1>
              <ul className="resource-list">

                <li>
                  <p><strong>811 </strong>(Also Known As the One Call Notification Center(s) in Your State)</p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pr-0 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          972-680-0261
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          info@dcaweb.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="google.com" target="_blank">dcaweb.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Common Ground Alliance</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          703-836-1709
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.commongroundalliance.com" target="_blank">commongroundalliance.com</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Distribution Contractors Association (DCA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          972-680-0261
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          info@dcaweb.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.dcaweb.org" target="_blank">dcaweb.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Cross Bore Safety Association (CBSA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          812-719-4800
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          information@crossboresafety.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.crossboresafety.org" target="_blank">crossboresafety.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Energy Equipment and Infrastructure Alliance (EEIA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          202-870-7715
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          info@eeia.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.eeia.org" target="_blank">eeia.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Center for Energy Workforce Development (CEWD) &ndash;</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          202-638-5802
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          staff@cewd.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.cewd.org" target="_blank">cewd.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>North American Excavation Shoring Association (NAXSA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          651-379-7307
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          info@naxsa.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.naxsa.org" target="_blank">naxsa.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>National Utility Contractors Association (NUCA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          703-358-9300
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          nuca@nuca.com
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.nuca.com" target="_blank">nuca.com</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>National Utility Locators Association</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-888-685-2246
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          executivedirector@nulca.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.nulca.org" target="_blank">nulca.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

              </ul>
              <h1>Pipelines</h1>
              <ul className="resource-list">

                <li>
                  <p><strong>Pipelines and Hazardous Materials Safety Administration (PHMSA) </strong>a division of the U.S. Department of Transportation.</p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          202-366-4595
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          Phmsa.pipelinesafety@dot.gov
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.phmsa.dot.gov" target="_blank">phmsa.dot.gov</a>
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.pipeline101.com" target="_blank">pipeline101.com</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

              </ul>
              <h1>Electric</h1>
              <ul className="resource-list">
                <li>
                  <p><strong>Federal Energy Regulatory Commission (FERC)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-866-208-3372
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="https://www.ferc.gov/industries/electric/indus-act.asp" target="_blank">ferc.gov</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Edison Electric Institute (EEI)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          202-508-5000
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.eei.org/about/contact/Pages/default.aspx" target="_blank">eei.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Electric Power Research Institute (EPRI)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-800-313-3774
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www2.epri.com/Help/Pages/Contact-Us.aspx" target="_blank">epri.com</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

              </ul>
              <h1>Water</h1>
              <ul className="resource-list">
                <li>
                  <p><strong>American Public Works Association (APWA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          (800) 848-APWA
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.apwa.net" target="_blank">apwa.net</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>American Water Works Association (AWWA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-800-926-7337
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="https://www.awwa.org/" target="_blank">awwa.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Water and Sewer Distributors of America (WSDA)</strong></p>
                  <ul>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.wasda.com" target="_blank">wasda.com</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>National Association of Clean Water Agencies (NACWA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-202-833-2672
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.nacwa.org/" target="_blank">nacwa.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Water Environment &amp; Reuse Foundation (WERF)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          571-384-2100
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.werf.org/" target="_blank">werf.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Water Environment Federation (WEF)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-800-666-0206
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="https://www.wef.org/" target="_blank">wef.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

              </ul>
              <h1>Sewer</h1>
              <ul className="resource-list">
                <li>
                  <p><strong>American Water Works Association (AWWA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-800-926-7337
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="https://www.awwa.org/" target="_blank">awwa.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>
              </ul>
              <h1>Cable</h1>
              <ul className="resource-list">
                <li>
                  <p><strong>National Cable and Telecommunications Association (NCTA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          202-222-2300,
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          webmaster@ncta.com
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="https://www.ncta.com/" target="_blank">ncta.com</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>American Cable Association (ACA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          412-922-8300
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.americancable.org/" target="_blank">americancable.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>National Cable Television Cooperative (NCTC)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          913-599-5900
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="email-icon" src={emailImage} alt="Email icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          help@nctconline.org
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="https://www.nctconline.org/index.php/about-nctc" target="_blank">nctconline.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

              </ul>
              <h1>Telecomm</h1>
              <ul className="resource-list">
                <li>
                  <p><strong>Telecommunications Industry Association (TIA)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-703-907-7700
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="http://www.tiaonline.org/about/contact-us" target="_blank">tiaonline.org</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

                <li>
                  <p><strong>Federal Communications Commission (FCC)</strong></p>
                  <ul>
                    <li className="row resource-list-item">
                      <div className="col-2 pr-md-0 h-100">
                        <div className="text-center">
                          <img className="phone-icon" src={phoneImage} alt="Phone icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          1-888-225-5322
                        </div>
                      </div>
                    </li>
                    <li className="row">
                      <div className="col-2 pr-md-0">
                        <div className="text-center">
                          <img className="computer-icon" src={computerImage} alt="Computer icon" />
                        </div>
                      </div>
                      <div className="col-8 col-md-10 pl-md-0 h-100">
                        <div className="vertical-aligned-content h-100">
                          <a href="https://www.fcc.gov/" target="_blank">fcc.gov</a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </li>

              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResourcesPage.propTypes = {};

export default ResourcesPage;



// WEBPACK FOOTER //
// ./src/components/pages/resources/ResourcesPage.js